const Slate = require('slate')

function insertExitBlock ({state, transform, block, after, text}) {
  const exitBlock = Slate.Block.create({
    type: 'paragraph',
    nodes: [
      Slate.Raw.deserializeText({
        kind: 'text',
        text: text || '\n'
      }, { terse: true })
    ]
  })

  const blockParent = state.document.getParent(block.key)
  let insertionIndex = blockParent.nodes.indexOf(block)
  if (after) { insertionIndex++ }

  return transform
    .insertNodeByKey(blockParent.key, insertionIndex, exitBlock)
    .collapseToStartOf(exitBlock)
    .focus()
}

module.exports = insertExitBlock



// WEBPACK FOOTER //
// ./src/slateUtils/insertExitBlock.js